import { HasPermission } from 'Core/security';
import { COACH_SSO_PERMISSION, COACHING_ROLE_USER_CODES, COACHING_TABS } from './constants';

/**
 * Access rule, through `Core/security` `HasPermission` exactly like the Sidebar entry: the account must
 * hold the `coachsso` site option and a sub-user must also hold one Coaching role code in its options.
 */
export const hasCoachingAccess = (user) =>
  HasPermission(user, COACH_SSO_PERMISSION, COACHING_ROLE_USER_CODES);

/**
 * Header tabs the user may open, in catalog order: the tabs whose `subuser` roles pass `HasPermission`.
 * The main account gets every tab; a sub-user gets the tabs of every role it holds.
 */
export const getAllowedTabs = (user) =>
  COACHING_TABS.filter((tab) => HasPermission(user, COACH_SSO_PERMISSION, tab.subuser));
